// Tijdkiezer van de ouder-webapp (packages/ui TimeField, docs/DESIGN.md §4.2 en §8.W3): typen of
// in twee tikken kiezen (eerst het uur, dan de minuten), en bij "Tot" de duur ten opzichte van
// "Van". Sleutels in `a.timePicker.*` (app.nl.ts).
export const appTimePickerNl = {
    /** Toegankelijke naam van de klokknop, met `{label}` (bv. "Van"). */
    open: '{label}: tijd kiezen',
    /** Kop van stap 1 en stap 2. */
    hourStep: 'Kies het uur',
    minuteStep: 'Kies de minuten',
    /** Namen van de rasters (schermlezer). */
    hours: 'Uren',
    minutes: 'Minuten',
    /** Schakelknopje (aria-pressed) dat de nachturen 00–05 toont. */
    showNight: 'Nacht 00–05',
    /** Terug naar stap 1. */
    back: 'Ander uur',
    close: 'Sluiten',
    /** Toetsenbord openen in plaats van kiezen (vooral op de telefoon). */
    type: 'Zelf typen',
    /** Rustige hint bij een tijd die we niet begrijpen; het getypte blijft staan. */
    invalid: 'Dat is geen tijd. Typ bijvoorbeeld 15:30 of 930.',
    /** Tot ligt op of vóór Van, met `{start}`. */
    beforeStart: 'Kies een tijd na {start}.',
    /** Van schoof zo laat dat Tot niet meer op dezelfde dag paste. */
    endClamped: 'Eindtijd ingekort tot 23:59.',
    /** Kop boven de duurknoppen in de kiezer en naam van de rij chips onder de velden. */
    durations: 'Hoe lang duurt het?',
    /** Kop boven het urenraster als er ook duurknoppen staan. */
    orPickEnd: 'Of kies een eindtijd',
    /** Toegankelijke naam van een duurknop: "1 uur, tot 16:30". */
    durationUntil: '{duration}, tot {time}',
    /** Duur: "30 min", "1 uur", "1½ uur", "1 uur 15 min". */
    minutesShort: '{count} min',
    hoursShort: { one: '{count} uur', other: '{count} uur' },
};
//# sourceMappingURL=timePicker.nl.js.map